export const THEME_V2_CLASS = 'decoro-v2';
